<template>
	<div :name="`name${data.qid}`" class="test_question list">
		<div
			class="title"
			:style="{
				fontSize: bandingstyle.appearance.fontStemSize + 'px',
				color: bandingstyle.appearance.fontStemColor,
				fontWeight: bandingstyle.appearance.fontStemBold,
				fontStyle: bandingstyle.appearance.fontStemItalic,
				textDecoration: bandingstyle.appearance.fontStemUnderline
			}"
		>
            <span v-if="data.mustanswer" class="required"></span>
			<HtmlClickImgEnlarge :content="data.questionsName"></HtmlClickImgEnlarge>
		</div>
		<div>
			<el-cascader
				:append-to-body="false"
				:style="{
					border: data.validate ? '1px solid red' : ''
				}"
				v-model="data.optionValue"
				:options="data.optionList"
				@change="handleChange"
			></el-cascader>
		</div>
		<div v-show="data.validate" class="form-item__error">{{ data.validateMsg }}</div>
	</div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue';
export default {
	name: 'cascadePC',
	components: {
		HtmlClickImgEnlarge
	},
	props: {
		data: {},
		bandingstyle: {}
	},
	data() {
		return {};
	},
	created() {
		console.log('1111', this.data);
		this.modifyFormat();
	},
	methods: {
		modifyFormat() {
			let optionList = JSON.parse(JSON.stringify(this.data.optionList));
			if (optionList.length > 0) {
				optionList.forEach(item => {
					item.value = item.label;
					if (item.children) {
						if (item.children.length > 0) {
							item.children.forEach(item2 => {
								item2.value = item2.label;
								if (item2.children) {
									if (item2.children.length > 0) {
										item2.children.forEach(item3 => {
											item3.value = item3.label;
											if (item3.children) {
												if (item3.children.length > 0) {
													item3.children.forEach(item4 => {
														item4.value = item4.label;
													});
												}
											}
										});
									}
								}
							});
						}
					}
				});
			}
			this.data.optionList = optionList;
			console.log(this.data.optionList)
		},
		handleChange(value) {
			console.log(value);
			console.log(this.data);
		}
	}
};
</script>

<style lang="scss" scoped>
.test_question {
	.option-box {
		display: flex;
		flex-direction: column;
		padding-left: 25px;
		.option + .option {
			margin-top: 10px;
		}
	}
}
.list {
	margin-top: 50px;
	.multiple {
		padding-left: 10px;
		.item-title {
			font-size: 14px;
			margin-bottom: 15px;
		}
	}
	.multiple + .multiple {
		margin-top: 20px;
	}
	.stem {
		padding-left: 10px;
		font-size: 14px;
		line-height: 30px;
	}
}
.required::before {
	content: '*';
	color: #f56c6c;
	margin-right: 4px;
}
.form-item__error {
	color: #f56c6c;
}
// .input__err > .el-input__inner {
// 	border-color: #f56c6c;
// 	.Rectinput{
// 		border-color: #f56c6c;
// 	}
// }
</style>
